export const endpoint = "https://mach-intranet.com:9000" // // ; ////"https://api.jptesting.co.uk:8080" //"http://localhost:5000"


export async function getTemplates(setTemplates, department, category) {
  let response = await fetch(`${endpoint}/templates/get/${department}/${category}`, {
    headers: {
      Authorization: "Bearer " + localStorage.token,
      DepartmentName: department
    },
  });
  let j = await response.json();
  let templates = {};
  for (let i = 0; i < Object.keys(j).length; i++) {
    templates[j[i]._id] = j[i];
  }
  setTemplates(j);
}

export async function getSections(setSections, department, category) {
  let response = await fetch(`${endpoint}/sections/${department}/${category}`, {
    headers: {
      Authorization: "Bearer " + localStorage.token,
      DepartmentName: department
    },
  });
  let j = await response.json();
  setSections(j);
}

export async function getSection(setSection, id, department) {
  let response = await fetch(`${endpoint}/sections/section/data/${id}`, {
    headers: {
      Authorization: "Bearer " + localStorage.token,
      DepartmentName: department
    },
  });
  let j = await response.json();
  setSection(j);
}

export async function getUsers(setUsers) {
  //load template
  let response = await fetch(`${endpoint}/users`, {
    headers: {
      Authorization: "Bearer " + localStorage.token
    }
  });

  let j = await response.json();
  let users = {};
  for (let i = 0; i < Object.keys(j).length; i++) {
    users[j[i]._id] = j[i];
  }
  setUsers(users);
}

export async function getUser(setUser)
{
    //load template
    let response = await fetch(`${endpoint}/users/me`,{
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer '+ localStorage.token
        } 
    });
    
    let j = await response.json();

    setUser(j);
}

export async function getCategories(setCategories, department) {
  let response = await fetch(`${endpoint}/categories/${department}`,{
      headers: {
          Authorization: 'Bearer '+ localStorage.token,
          DepartmentName: department
      }
  } );

  let j = await response.json();
  let categories = {}
  for (let i = 0; i < Object.keys(j).length; i++) {
      categories[j[i]._id] = j[i];
  }    
  setCategories(j);
}


export async function getTags(setTags, department) {
  let response = await fetch(`${endpoint}/tags/${department}`, {
    headers: {
      Authorization: "Bearer " + localStorage.token,
      DepartmentName: department
    },
  });
  let j = await response.json();

  let tagNames = []
  j.map(tag => {
    tagNames.push(tag.name);
  } )
  setTags(tagNames);
}

export async function getDepartments(setDepartments)
{
    //load template
    let response = await fetch(`${endpoint}/departments`,{
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer '+ localStorage.token
        } 
    });
    
    let j = await response.json();
    let departments = {}
    for (let i = 0; i < Object.keys(j).length; i++) {
        departments[j[i]._id] = j[i];
    }

    setDepartments(departments);
}

export async function getDepartmentPermissions(setDepartmentPermission, department)
{
    let response = await fetch(`${endpoint}/departments/check/departmentpermission/${department}`,{
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer '+ localStorage.token,
            DepartmentName: department
        } 
    });    
    let j = await response.json();
    setDepartmentPermission(j);
}

export async function getDesignatedDepartments(setDesignated)
{
    //load template
    let response = await fetch(`${endpoint}/departments/designated`,{
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer '+ localStorage.token
        } 
    });
    
    let j = await response.json();
    setDesignated(j);
}

export async function getFiles(setFiles)
{
    //load template
    let response = await fetch(`${endpoint}/reports`,{
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer '+ localStorage.token
        } 
    });
    
    let j = await response.json();
    let teams = {}
    for (let i = 0; i < Object.keys(j).length; i++) {
        teams[j[i]._id] = j[i];
    }

    setFiles(j);
}

